import gears from "../../assets/images/gears.gif";
import icon from "../../assets/images/icon.png";
import { Auth } from "../../util/auth";
import { getNomenclatureConfiguration,sideNavClicked } from "../side-nav/side-nav";
import { checkCurrentPassword, validateForm,changePassword } from "./change-password";
import {
    checkToChangeRole,
    getCollegeData,
    getHelpDeskInfo,
    getNotificationCount,
    markReadNotifications,
    searchUser,
    setUserSessionOut,
    getStudentFeeDetailsByConfiguration,
    getAdmissionCommonConfig,
    getStudentDataConfigByDegreeId,
    getAllDueDateByDegree,
    getDefaultInformationForChild
} from "./common-api";
import { getWebSocket, setNotification, stompClient } from "./websocket";
import { getURL } from '../../util/util';


var blockWidth = true;

export var header = `<header class="header mainapp common-header main-header">
<nav id="main">
    <!-- Heraizen Logo starts -->
    <a id="logoId" class="logo  left-shift full-sidebar">
        <span id="logo-sm" class="header-logo-mini"><img id="mini-logo"  style="height: 50px; margin: auto; max-width: 10em;" src=""></span>
        <span id="logo-md" class="header-logo-lg"><img id="full-logo" style="height: 50px; margin: auto; max-width: 10em;" src=""></span>
    </a>
    <!-- Heraizen Logo ends -->

    <!-- Toggle button to hide and show of nav bar starts -->
    <div class="header-item-list left-shift">
        <button id="togglebtn" class="header-item-new" title="Toggle">
        <i id="panel-menu" class="fa fa-bars"></i>
        </button>
    </div>
    <!-- Toggle button to hide and show of nav bar ends -->
<!--------College Name -------------------------------------->
<div class="college-name-item left-shift">  
<span id="college-name"></span>
</div>
<!----------------College Names end here ------------------------>

 <!-- Notification Dropdown Starts-->

 <div class="header-item-list right-shift">
        <button id="notificationbtn" class="header-item" title="Notification">
            <i id="notificationIcon" class="fa fa-bell"></i>
            <span id="notificationCount" class="notificaion-count-badge">
            </span>
        </button>
        <div class="dropdown-content  notification-content" id="notify">
            <div class="notification-content-header">
                <p id="noOfNotification"></p>
            </div>
            <div class="notification-content-body" id="notifications">
                <div class="sub-notification" id="notification">

                </div>
            </div>
        </div>
    </div>
    <!-- Notification Dropdown Ends-->


    <!-- Helpdesk Info Dropdown sthelpdeskbtnarts-->
    <div class="header-item-list right-shift">
        <button id="helpdeskbtn" class="header-item" title="Help Desk Info">
            <i id="helpdeskIcon" class="fa fa-question-circle"></i>
        </button>
        <div class="dropdown-content" id="helpdesk">
            <div class="helpdesk-content-image">
                <img id="organiztionImg" src='' height="50" width="70">
            </div>
            <div class="helpdesk-content-body">
                <small id="organizationEmail"></small>
                <small id="organizationContactNo"></small>
            </div>
            <hr class="color-header">
            <div class="helpdesk-content-footer">
                <small id="organizationName">
                </small>
            </div>
        </div>
    </div>
    <!-- Helpdesk Info Dropdown starts-->
    <!-- theme Switch starts -->
    <div class="header-item-list right-shift">
            <button id="themeSwitchBtn" class="header-item">
                <i id="themeSwitchIcon" class="fa fa-gears"></i>
            </button>
            <div class="dropdown-content  theme-content" id="theme">
                    <div class="cursor-as-pointer" id="themeSwitchBtn1">
                        <span  class="role-menu-other-roles-details theme-icon-size">
                        <i class="las la-palette palette-size" aria-hidden="true"></i> Select theme
                        </span>
                    </div>
            </div>
        </div>
      <!-- theme Switch ends -->
    <!-- Chat starts-->
    <!-- <div class="header-item-list right-shift">
                <button id="chatbtn" onclick="history.pushState(null, 'Helpdesk Details', '/#/content-management-angular/content-management/helpdeskdetails')" class="header-item" title="Helpdesk Details">
  <i id="chatIcon" class="fa fa-comments"></i>
</button>
        
    </div>-->
 <!-- Chat Ends-->
<!---Fee Details And Wallet Details start here--------------------->
     <div class="header-item-list right-shift" id="feeDetails">
    <button id="feeDetailsbtn" type="button" class="button-style header-item">
        &nbsp;
        <span class="border-around">
            <span id="currencySymbol1" class="margin-color"></span>
            <span id="dropdownIcon" class="dropdown-icon" style="font-size: 18px; cursor: pointer;">&#9662;</span>
        </span>
    </button>
      <div class="dropdown-content fee-details-content" id="feeDetailsDropdown">
            <br>
                <div id="fee-or-wallet">
                        <button type="button" id="feeDetailsBtn" class="btn-color btn-common">
                            My Fee Details
                        </button>                  
                        <button type="button" id="walletDetailsBtn" class="btn-common ">
                            My Wallet
                        </button>                
                </div>
            <hr>
            <br>
            <!---My Fee Details  start here--------------------->
            <div id="feeDetailsSection">
            <div id="showYearOrTerm">
          
              <div class="fee-details-info row" id="previousBalance">
                <small class="col-md-6">Previous Balance (<span id="prevSymbol"></span>)</small>
                <small class="col-md-1">:</small>
                <small class="col-md-5"><span id="prevBalance"></span></small>
              </div>
          
              <div class="fee-details-info row" id="currYearPayable">
                <small class="col-md-6">Current Year Payable (<span id="currYearPayableSymbol"></span>)</small>
                <small class="col-md-1">:</small>
                <small class="col-md-5"><span id="currentYearPayable"></span></small>
              </div>
          
              <div class="fee-details-info row" id="totalPay">
                <small class="col-md-6">Total Payable (<span id="totalPaySymbol"></span>)</small>
                <small class="col-md-1">:</small>
                <small class="col-md-5"><span id="totalPayable"></span></small>
              </div>
          
              <div class="fee-details-info row" id="curYearPaid">
                <small class="col-md-6">Current Year Paid (<span id="curYearPaidSymbol"></span>)</small>
                <small class="col-md-1">:</small>
                <small class="col-md-5"><span id="currentYearPaid"></span></small>
              </div>
          
              <div class="fee-details-info row" id="curYearBal">
                <small class="col-md-6">Current Year Balance (<span id="curYearBalSymbol"></span>)</small>
                <small class="col-md-1">:</small>
                <small class="col-md-5"><span id="currentYearBal"></span></small>
              </div>
          
              <div class="fee-details-info row" id="totalBal">
                <small class="col-md-6">Total Balance (<span id="totalBalSymbol"></span>)</small>
                <small class="col-md-1">:</small>
                <small class="col-md-5"><span id="totalBalance"></span></small>
              </div>
          
              <div class="fee-details-info row" id="totalPaid">
                <small class="col-md-6">Total Paid (<span id="totalPaidSymbol"></span>)</small>
                <small class="col-md-1">:</small>
                <small class="col-md-5"><span id="totalPaidValue"></span></small>
              </div>
          
              <div class="fee-details-info row" id="excessAmt">
                <small class="col-md-6">Excess Amount (<span id="excessAmtSymbol"></span>)</small>
                <small class="col-md-1">:</small>
                <small class="col-md-5"><span id="excessAmount"></span></small>
              </div>
          <br>
              <div class="fee-details-info" id="termWiseFeeDetails">
                <b><u>Termwise Fee Details</u></b>
                <p class="fee-details-info" id="eachTermDetails"></p>
              </div>
          
              <div class="fee-details-info" id="otherFeeDetails">
                <p class="fee-details-info" id="eachYearDetails"></p>
              </div>
          
            </div>
          
            <div id="hideTermOrYear">
              <div class="fee-details-info row" id="totalBalNoTermOrYear">
                <small class="col-md-6">Total Balance (<span id="totalBalNoTermOrYearSymbol"></span>)</small>
                <small class="col-md-1">:</small>
                <small class="col-md-5"><span id="totalBalanceNoTermOrYear"></span></small>
              </div>
          
              <div class="fee-details-info row" id="totalPayableNoTermOrYear">
                <small class="col-md-6">Total Payable (<span id="totalPayableNoTermOrYearSymbol"></span>)</small>
                <small class="col-md-1">:</small>
                <small class="col-md-5"><span id="totalPayableNoTermOrYear"></span></small>
              </div>
          
              <div class="fee-details-info row" id="totalPaidNoTermOrYear">
                <small class="col-md-6">Total Paid (<span id="totalPaidNoTermOrYearSymbol"></span>)</small>
                <small class="col-md-1">:</small>
                <small class="col-md-5"><span id="totalPaidNoTermOrYear"></span></small>
              </div>
            </div>
          
            <br>
          
            <div id="fee-Details-paybtn">
              <button id="payBalancebtn" class="feebutton">
                <i class="fa fa-money" aria-hidden="true"></i> Pay Now
              </button>
            </div>
          
            <br>
          </div>
          
        <!---My Fee Details  Ends here--------------------->
    <!---My Wallet start here--------------------->
    <div id="walletSection" style="display: none;">
    <ul class="menu">
        <li class="dropboxsize">
            <div class="wallet-container text-black">
                <div class="wallet-left ">
                    <i class="fa fa-briefcase" style="font-size: 2rem;"></i>
                </div>
                <div class="vertical-line"></div>
                <div class="wallet-right">
                    <div class="wallet-balance-label">Wallet Balance</div>
                    <div class="wallet-balance-value">
                        <span id="currencySymbolfromConfig"></span>
                        <span id="walletAmount"></span>
                    </div>
                </div>
            </div>
            <div class="button-container">
                <button type="button"  class="feebutton" id="wallethistory">
                    <span>
                        <i class="fa fa-clock-o"></i> View Transaction History
                    </span>
                </button>
            </div>
        </li>
      </ul>
    </div>
  <!--- My Wallet  ends here--------------------->
      </div>
    </div>
<!---Fee Details And Wallet Details ends here--------------------->
    <!-- Role Change Dropdown starts-->
    <div class="header-item-list right-shift">
        <button id="rolebtn" class="header-item">
            <span id="userImageCircleId" class="user-sm-image">
                <p id="userHeaderIcon" class="starting-letter"> </p>
                <img id="userHeaderImage" src="">
            </span>
            <span id="username" class="role-menu"></span>
        </button>
        <div class="dropdown-content role-menu-content" id="roleDropdown">
            <div class="role-menu-content-role-details">
                <div class="user-image user-image-circle">
                    <p id="userPopupIcon" class="role-menu-image-details"> </p>
                    <img id="userPopUpImage" src="">
                </div>
                <p id="userName" class="role-menu-username-details"></p>
                <small class="color-white">
                    <p id="email"></p>
                </small>
                <br>
                <small class="color-white">Department: <p id="department"></p></small>

            </div>
            <div class="role-menu-other-roles-details">
                <p id="role" class="cursor-as-pointer"></p>
            </div>
            
            <div class="role-menu-other-roles-details">
            <button style="width:50%;" id="openChangePassword" class="root-btn left-shift">Change Password</button>
                <button style="width:30%;" id="logoutBtn" class="root-btn right-shift">Logout</button>
            </div>
        </div>
    </div>
    <!-- Role Change Dropdown ends-->


    <!-- Degree Switch starts -->
    <div class="header-item-list right-shift" id="degreeSwitchDropdown">
      <button id="degreeSwitchBtn" type="button" class="header-item" title="Degree Switch">
        <i class="fa fa-graduation-cap" id="degree-switch-icon"></i>
        <span class="icontextalign" id="currentDegree"></span>
        <i class="fa fa-angle-down degree-switch-arrow" id="degree-switch-icon2"></i>
      </button>
      <div class="dropdown-content degree-switch-menu-content" id="degreeSwitchDropdownContent">
      
      </div>
    </div>
    <!-- Degree Switch ends -->
  
  <!-- Instituion switch Switch starts -->
    <div class="header-item-list right-shift" id="institutionSwitchDropdown">
      <button id="institutionSwitchbtn" type="button" class="header-item" title="Institution Switch">
        <i class="fa fa-graduation-cap" id="institution-switch-icon"></i>
        <span class="icontextalign" id="currentInstitution"></span>
        <i class="fa fa-angle-down degree-switch-arrow" id="institution-switch-icon2"></i>
      </button>
      <div class="dropdown-content degree-switch-menu-content" id="institutionSwitchDropdownContent">

      </div>
    </div>
    <!-- Instituion Switch ends -->

    <!-- Global Search starts -->
     <div class="header-item-list right-shift" id="globalSearch">
     <div class="search-container">
      <input class="header-search-input" placeholder="Search Profile" id="globalSearchInput" name="globalSearch">
       <i class="header-search-icon fa fa-search" id="globalSearchIcon"></i>
       </div>
      <div class="dropdown-content global-search-dropdown-content search-scrollbar" id="globalSearchResults">
      </div>
    </div>
    <div class="header-item-list right-shift hide"  id="searchbtn" >
        <button class="header-item"  id="searchiconbtn">
        <i class=" fa fa-search" id="searchicon"></i>
        </button>
    </div> 
    <!-- Global Search ends -->
    <!--chat starts here-->
 <!--<div class="cursor-pointer" onclick="history.pushState(null,'collaboration-angular/chat','/collaboration-angular/chat')"><i class="fa fa-comments" aria-hidden="true"></i></div>-->

 <!--chat ends here-->
    <!-- Change Password Modal -->
    <div id="change-password-modal" class="modal">
        <!-- Modal content -->
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="change-password-modal-header">Change Your Password<span id="closemodal"
                        class="close-modal right-shift">&times;</span></h4>
            </div>
            <div class="modal-body">
                <input type="text" id="currentPassword" name="currentPassword" placeholder="Current Password"
                    required>
                <p id="curPassErrorMsg" class="color-red"></p>
                <input type="text" id="newPassword" name="newPassword" placeholder="New Password" required>
                <p id="newPassErrorMsg" class="color-red"></p>
                <input type="text" id="confirmPassword" name="confirmPassword" placeholder="Retype New Password"
                    required>
                <p id="confirmPassErrorMsg" class="color-red"></p>
                <button class="root-btn submit-btn" id="changePasswordBtn" disabled="disabled">Submit</button>
            </div>
            <div class="modal-footer">
                <input id="closebtn" class="root-btn cancel-btn" type="button" value="Cancel">
            </div>
        </div>
    </div>
    <div id="logout-confirmation-modal" class="modal">
        <!-- Modal content -->
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="change-password-modal-header"> Alert!!<span id="closemodal"
                        class="close-modal right-shift">&times;</span></h4>
            </div>
            <div class="modal-body">
                <p class="default-message">
                    Your section has been updated, please log out and log in again to get the update.
                </p>
            </div>
            <div class="modal-footer">
                <input id="logoutconfbtn" class="root-btn cancel-btn" type="button" value="Logout">
            </div>
        </div>
    </div>

    <!-- theme modal starts -->
    <div id="modal-backdrop" class="modal-backdrop hide"></div>

    <div id="change-theme-modal"  class="modal" data-bs-backdrop="static" data-bs-keyboard="false">
             <div class="change-theme-modal-header">
                    <span >Select Theme<span id="closethememodal"
                    class="close-modal right-shift">&times;</span></span>
        </div>
                <div class="modal-body">
            <div id="themes-container" class="p-2 m-1"></div>
        </div>
        
            <div class="modal-footer">
                <button class="btn other-button" id="applyChangesBtn"> <span class="select-button-tick-box">&nbsp;</span>&nbsp;Select</button>
        </div>
        </div>
        <!-- theme modal ends -->

</nav>
</header>
`;
var toggleBtnClicked = true;
var modal;
var logoutConfirmModal;
// college
var college;
var miniHeaderLogo;
var headerLogo;

// user
var user;
var currentRole;
var userImage;
var roles;
var lastName;
var name;
var title;
var userDeptName;
var email;
// notifications
var notifications;
var noOfNotifications;

//helpdesk
var helpDeskDetails;
var organizationName;

// Global Search
var searchResults = [];
var keycloak;
var studentFeeDetails;
var admissionCommonConfiguration;
let walletAmt;
var institutionGraduationTypes = [];
var currentRoleLevel;

var degreeId = "";
var dueDateAndFine = [];
var academicYear = "";
var currentYear ;
var termNumber = "";
var disablePayNow = false;
var studentDataConfig = {};
var selectedTheme;
var themeModal;
var feeCollectionTermWise = false;
const themes = [
    {
      name: 'Happiness',
      data: 'basic',
      primary: '#76323f',
      secondary: '#00303f',
      background: '#e8e5e5',
    },
    {
      name: 'Joy',
      data: 'klorofeel',
      primary: '#92c256',
      secondary: '#f8e24e',
      background: '#f6eeaf',
    },
    {
      name: 'Courage',
      data: 'tdsb',
      primary: '#4974a9',
      secondary: '#ffe3a2',
      background: '#c8e6e4',
    }, {
      name: 'Ocean',
      data: 'theme1',
      primary: '#C2E0E7',
      secondary: '#00B4D8',
      background: '#F2F3F5',
    }, {
      name: 'Royal',
      data: 'theme2',
      primary: '#8AB1DE',
      secondary: '#2869B4',
      background: '#F2F3F5',
    }, {
      name: 'Serene',
      data: 'theme3',
      primary: '#FDB913',
      secondary: '#2E3193',
      background: '#D2D3EB',
    }
  ];

 

/**
 * @description showDegreeSwitchDropdown is used to show degree switch pop-up
 *
 * @author Arupananda P
 * @since June 26, 2020
 */
function showDegreeSwitchDropdown() {
    addTopAnimation("degreeSwitchDropdownContent", "degreeSwitchBtn");
    document
        .getElementById("degree-switch-icon2")
        .classList.remove("fa-angle-down");
    document.getElementById("degree-switch-icon2").classList.add("fa-angle-up");
}
function showInstitutionSwitchDropdown() {
    addTopAnimation("institutionSwitchDropdownContent", "institutionSwitchbtn");
    document
        .getElementById("institution-switch-icon2")
        .classList.remove("fa-angle-down");
    document.getElementById("institution-switch-icon2").classList.add("fa-angle-up");
}

/**
 * @description hideInstitutionSwitchDropdown is used to show degree switch pop-up
 *
 * @author Arupananda P
 * @since June 26, 2020
 */
function hideInstitutionSwitchDropdown() {
    removeTopAnimation("institutionSwitchDropdownContent", "institutionSwitchbtn");
}
/**
 * @description hideDegreeSwitchDropdown is used to hide degree switch pop-up
 *
 * @author Arupananda P
 * @since June 26, 2020
 */
function hideDegreeSwitchDropdown() {
    removeTopAnimation("degreeSwitchDropdownContent", "degreeSwitchBtn");
}


/**
 * @description To open the Change password modal
 * @author Aishwarya AK
 */
function openModal() {
        const admissionUrl = `/#/auth-mf/cred/change-password`;
    history.pushState(
        admissionUrl,
        admissionUrl,
        window.location.origin+"/"+Auth.getTenantId()+'/mfrootconfig' + admissionUrl
    );
    // modal.style.display = "block";
    // modal.style.width = "30%";
    // modal.style.position = "fixed";
    // modal.style.top = "30%";
    // modal.style.left = "50%";
    // modal.style.transform = "translate(-50%, -50%)";
    // modal.style.background = "white";  // Ensure it has a solid background
    // modal.style.boxShadow = "0px 4px 10px rgba(0, 0, 0, 0.2)"; // Add shadow for a floating effect
    // modal.style.height = "unset";
    // modal.style.zIndex = "1000"; // Ensure it's above everything else


    // // Ensure modal-content takes full width
    // let modalContent = modal.querySelector(".modal-content");
    // if (modalContent) {
    //     modalContent.style.display = "flex";
    //     modalContent.style.flexDirection = "column";
    //     modalContent.style.width = "100%";
    //     modalContent.style.boxSizing = "border-box";
    // }

    // // Ensure modal-footer is inside the modal
    // let modalFooter = modal.querySelector(".modal-footer");
    // if (modalFooter) {
    //     modalFooter.style.display = "flex";
    //     modalFooter.style.justifyContent = "flex-end"; // Align cancel button
    //     modalFooter.style.padding = "10px";
    //     modalFooter.style.width = "100%";
    //     modalFooter.style.boxSizing = "border-box";
    // }

    // // Ensure buttons don’t overflow
    // let buttons = modal.querySelectorAll("button, input[type='button']");
    // buttons.forEach(button => {
    //     button.style.maxWidth = "100%";
    //     button.style.whiteSpace = "nowrap";
    // });

    // // Prevent scrolling on body when modal is open
    // document.body.style.overflow = "hidden";
}

/**
 * @description To close the change password modal
 * @author Aishwarya AK
 */
function closeModal() {
    let modal = document.getElementById("change-password-modal");
    modal.style.display = "none";
    document.body.style.overflow = "auto";
}

/**
 * @description To open the Change password modal
 * @author Aishwarya AK
 */
export function openLogoutConfirmModal() {
    logoutConfirmModal.style.display = "block";
}

/**
 * @description To close the change password modal
 * @author Aishwarya AK
 */
export function closeLogoutConfirmModal() {
    logoutConfirmModal.style.display = "none";
}

export function openThemeModal() {
    themeModal.style.display = "block";
    document.getElementById("modal-backdrop").classList.remove("hide");
  }
  
  
  export function closeThemeModal(theme) {
    document.getElementById("modal-backdrop").classList.add("hide");
    themeModal.style.display = "none";
    user = Auth.getUser();
    selectedTheme = theme || user.theme || themes[0].data;
}
  

/**
 * @description
 * @author Aishwarya AK
 */
function showLoader() {
    document.getElementById("loderBg").style.display = "block";
    document.getElementById("loderBg").style.width = "100%";
    document.getElementById("loderBg").style.height = "100%";
    document.getElementById("loderImg").style.paddingLeft = "50%";
    document.getElementById("loderImg").style.paddingTop = "20%";
}

/**
 * @description to open the sidenav bar
 * @author Aishwarya AK
 */
function openNavBar() {
    document.getElementById("mySidebar").classList.remove("mini-sidebar");
    document.getElementById("mySidebar").classList.add("full-sidebar");
    document.getElementById("logoId").classList.remove("mini-sidebar");
    document.getElementById("logoId").classList.add("full-sidebar");
    document.getElementById("logo-md").classList.remove("hide");
    document.getElementById("logo-sm").classList.add("hide");
    // document.getElementById("panel-menu").classList.add("fa-rotate-90");
    if (screen.width >= 767) {
        document.getElementById("subapp-container").style.marginLeft = "16em";;
    }
    if (screen.width <= 480 && screen.width > 320) {
        let elems = document.getElementsByClassName("header-item");
        for (var i = 0; i < elems.length; i++) {
            if (elems[i].id != "rolebtn" || elems[i].id != "insbtn") {
                // setTimeout(() => {
                elems[i].classList.add("hide");
                // }, 100);
            }
        }

        document.getElementById("globalSearch") && (document.getElementById("globalSearch").classList.add("hide"));
        document.getElementById("searchbtn") && (document.getElementById("searchbtn").classList.remove("hide"));

        // document.getElementById("degreeSwitchDropdown").classList.add("hide");
        // document.getElementById("helpdeskbtn").classList.add("hide");
        // document.getElementById("notificationbtn").classList.add("hide");
    }
    if (screen.width <= 320) {
        let elems = document.getElementsByClassName("header-item");
        for (var i = 0; i < elems.length; i++) {
            elems[i].classList.add("hide");
            // setTimeout(() => {
            //   elems[i].classList.add("hide");
            // }, 100);
        }
        document.getElementById("globalSearch") && (document.getElementById("globalSearch").classList.add("hide"));

         document.getElementById("globalSearchInput") && (document.getElementById("globalSearchInput").classList.add("hide"));
        document.getElementById("rolebtn").classList.add("hide");
        document.getElementById("insbtn") && (document.getElementById("insbtn").classList.add("hide"));

        // document.getElementById("searchbtn").classList.add("hide");
        // document.getElementById("degreeSwitchDropdown").classList.add("hide");
        // document.getElementById("helpdeskbtn").classList.add("hide");
        // document.getElementById("notificationbtn").classList.add("hide");
    }
}

/**
 * @description to close the sidenav bar
 * @author Aishwarya AK
 */
function closeNavBar() {
    document.getElementById("mySidebar").classList.remove("full-sidebar");
    document.getElementById("mySidebar").classList.add("mini-sidebar");
    document.getElementById("logo-md").classList.add("hide");
    document.getElementById("logo-sm").classList.remove("hide");
    document.getElementById("logoId").classList.remove("full-sidebar");
    document.getElementById("logoId").classList.add("mini-sidebar");
    // document.getElementById("panel-menu").classList.remove("fa-rotate-90");
    if (screen.width >= 767) {
        document.getElementById("subapp-container").style.marginLeft = "56px";
    }
    if (screen.width < 767) {
        document.getElementById("subapp-container").style.marginLeft = "0px";
    }
    // document.getElementById("subapp-container").style.marginLeft = "5em";
    if (screen.width <= 480 && screen.width > 320) {
        setTimeout(() => {
            let elems = document.getElementsByClassName("header-item");
            for (var i = 0; i < elems.length; i++) {
                if (elems[i].id != "rolebtn" || elems[i].id != "insbtn") {
                    elems[i].classList.remove("hide");
                }
            }
            changeSearchDesign();
        }, 700);
    }
    if (screen.width <= 320) {
        setTimeout(() => {
            let elems = document.getElementsByClassName("header-item");
            for (var i = 0; i < elems.length; i++) {
                elems[i].classList.remove("hide");
            }
            changeSearchDesign();
        }, 700);
    }
}

function changeSearchDesign() {
   document.getElementById("globalSearch") &&  (document.getElementById("globalSearch").classList.remove("hide"));
   document.getElementById("globalSearchInput") && (document.getElementById("globalSearchInput").classList.add("hide"));
   document.getElementById("searchbtn") &&  (document.getElementById("searchbtn").classList.remove("hide"));
}

/**
 * @description setting header logo
 * @author Aishwarya AK
 */
function setHeaderLogo() {
    college = Auth.getCollegeInfo();
    miniHeaderLogo = college.headerMiniLogo;
    headerLogo = college.headerLogo;
    document.getElementById("mini-logo").src =
        "data:image/png;base64," + miniHeaderLogo;
    document.getElementById("full-logo").src =
        "data:image/png;base64," + headerLogo;
    document.getElementById("college-name").innerHTML = college.collegeName;
}

function getEmptyIfNull(val) {
    if (val == null || val == undefined) {
        return "";
    }
    return val;
}

/**
 * @description sets user details
 * @author Aishwarya AK
 */
function setUserDetails() {
    user = Auth.getUser();
    if (user != null) {
        userImage = user.image;
        roles = user.roles;
        lastName = user.lastName;
        name = user.name;
        title = user.title;
        userDeptName = user.deptName;
        email = user.email;
        currentRole = Auth.getCurrentRole();
        if (userImage != null) {
            document.getElementById("userHeaderImage").src =
                "data:image/png;base64," + userImage;
            document.getElementById("userHeaderIcon").innerHTML = "";
            document.getElementById("userPopUpImage").src =
                "data:image/png;base64," + userImage;
            document.getElementById("userPopupIcon").innerHTML = "";
        } else {
            document.getElementById("userHeaderImage").src = "";
            document.getElementById("userHeaderIcon").innerHTML =
                "<i id='userIcon' class='fa fa-user-o' aria-hidden='true'></i>";
            document.getElementById("userPopUpImage").src = "";
            document.getElementById("userPopupIcon").innerHTML =
                "<i class='fa fa-user-o' aria-hidden='true'></i>";
        }
        document.getElementById("username").innerHTML =
            getEmptyIfNull(title) +
            " " +
            getEmptyIfNull(name) +
            " " +
            getEmptyIfNull(lastName) +
            " [ " +
            getRoleDisplayName(roles, currentRole) +
            " ] ";
   // Call the method to hide the search bar for specific Current Role  after setting user details
        hideSearchBar();
        selectedTheme = user.theme || themes[0].data;
    }
}

function getRoleDisplayName(roles, currentRole) {
    const selectedRole = roles.find(role => role.roleName === currentRole);
    return removeUnderScore(selectedRole ?
        (selectedRole.roleDisplayName ? selectedRole.roleDisplayName : currentRole) : currentRole);
}

function removeUnderScore(roleName) {
    return roleName.replace(/_/g, ' ');
}

function isRole(id, roles) {
    for (var i = 0; i < roles.length; i++) {
        if (id == roles[i].roleName) {
            return true;
        }
    }
    return false;
}



function setUserImageAndDetails(user, currentRole) {
    if (user != null && userImage != null) {
        document.getElementById("userPopUpImage").src =
            "data:image/png;base64," + userImage;
        document.getElementById("userPopupIcon").innerHTML = "";
    } else {
        document.getElementById("userPopUpImage").src = "";
        document.getElementById("userPopupIcon").innerHTML =
            "<i class='fa fa-user-o' aria-hidden='true'></i>";
    }

    document.getElementById("userName").innerHTML =
        getEmptyIfNull(title) +
        " " +
        getEmptyIfNull(name) +
        " " +
        getEmptyIfNull(lastName) +
        " - " +
        getRoleDisplayName(roles, currentRole);
    document.getElementById("department").innerHTML = userDeptName;
    document.getElementById("email").innerHTML = email;
}

function setCollegeName() {

    let college = JSON.parse(window.sessionStorage.getItem('college'));
    if (college) {
        const collegeName = college.collegeName;
        document.getElementById("collegeName").innerHTML =
            getEmptyIfNull(collegeName)
    }
}

function createRoleSwichButtons(user, currentRole) {
    var i,
        buttons = "";
    for (i = 0; i < user.roles.length; i++) {
        var button;
        if (user.roles[i].roleName === currentRole) {
            button =
                "<button style='width:100%' id='" +
                user.roles[i].roleName +
                "' class='root-btn selected-btn'>" +
                (removeUnderScore(user.roles[i].roleDisplayName != null ? user.roles[i].roleDisplayName : user.roles[i].roleName)) +
                "</button>" +
                "<br>";
        } else {
            button =
                "<button style='width:100%' id='" +
                user.roles[i].roleName +
                "' class='root-btn'>" +
                (removeUnderScore(user.roles[i].roleDisplayName != null ? user.roles[i].roleDisplayName : user.roles[i].roleName)) +
                "</button>" +
                "<br>";
        }
        buttons += button;
    }
    document.getElementById("role").innerHTML = buttons;
}

function setAllNotifications(notifications) {
    var notificationList = "";
    var notificationIcon = '<i class="fa fa-bars"></i>&nbsp;&nbsp;&nbsp;';
    
    for (var i = 0; i < notifications.length; i++) {
        notificationList +=
            notificationIcon + notifications[i].notificationMessage + "<br><br>";
    }


    let notificationText = notifications.length === 1 ? " notification" : " notifications";

    document.getElementById("noOfNotification").innerHTML =
        "You have " + notifications.length + notificationText;

    document.getElementById("notification").innerHTML = notificationList;

    if (notificationList.length === 0) {
        document.getElementById("notifications").style.display = "none";
    }
}

export function setNotificationCount() {
    getNotificationCount().then((resp) => {
        if (resp != undefined) {
            var responses = JSON.parse(JSON.stringify(resp));
            if (responses != undefined && responses.length > 0) {
                document.getElementById("notificationCount").innerHTML =
                    responses.length;
                document.getElementById("notificationCount").style.display = "block";
                for (var i = 0; i < responses.length; i++) {
                    setNotification(responses[i], false);
                }
                setAllNotifications(responses);
            } else {
                document.getElementById("notificationCount").innerHTML = "";
                document.getElementById("notifications").style.display = "none";
                document.getElementById("noOfNotification").innerHTML =
                    "You have no notification";
            }
        }
    });
}

function showRoleDropdown() {
    addTopAnimation("roleDropdown", "rolebtn");
}




function addTopAnimation(dropdownId, btnId) {
    if(document.getElementById(dropdownId)){
    document.getElementById(dropdownId).classList.add("show-top-animation");
    document.getElementById(dropdownId).classList.remove("hide-top-animation");
    if (btnId) {
        document.getElementById(btnId).classList.remove("header-item");
        document.getElementById(btnId).classList.add("header-item-selected");
    }
    document.getElementById(dropdownId).classList.remove("hide");
}
}

function removeTopAnimation(dropdownId, btnId) {
    if (
         document.getElementById(dropdownId) && document.getElementById(dropdownId).classList.contains("show-top-animation")
    ) {
        document.getElementById(dropdownId).classList.remove("show-top-animation");
        document.getElementById(dropdownId).classList.add("hide-top-animation");
        if (btnId) {
            document.getElementById(btnId).classList.remove("header-item-selected");
            document.getElementById(btnId).classList.add("header-item");
        }
        if (btnId == "degreeSwitchBtn") {
            document
                .getElementById("degree-switch-icon2")
                .classList.remove("fa-angle-up");
            document
                .getElementById("degree-switch-icon2")
                .classList.add("fa-angle-down");
        }
        if (btnId == "institutionSwitchbtn") {
            document
                .getElementById("institution-switch-icon2")
                .classList.remove("fa-angle-up");
            document
                .getElementById("institution-switch-icon2")
                .classList.add("fa-angle-down");
        }
        setTimeout(() => {
            document.getElementById(dropdownId).classList.add("hide");
        }, 400);
    }
}

function showNotificationDropdown() {
    addTopAnimation("notify", "notificationbtn");
}

function hideRoleDropdown() {
    removeTopAnimation("roleDropdown", "rolebtn");
}


function hideNotificationDropdown() {
    removeTopAnimation("notify", "notificationbtn");
}

function hideHelpDeskDropdown() {
    removeTopAnimation("helpdesk", "helpdeskbtn");
}

function showHelpdeskDropdown() {
    addTopAnimation("helpdesk", "helpdeskbtn");
}

function showThemeDropdown() {
    addTopAnimation("theme", "themeSwitchBtn");
}

function hideThemeDropdown() {
    removeTopAnimation("theme", "themeSwitchBtn");
}

/**
 * @description getHandlingDegreeDepts is used to get HandlingDegreeDepartments from Logged in user.
 *
 * @author Masthanaiah K
 * @since Feb 13, 2025
 */
function getHandlingDegreeDepts(selectedInstitution) {
    currentRoleLevel = getCurrentRoleLevel();
    if (Auth.getAcademicLevel() != 'UNIVERSITY') {
         user=Auth.getUser();
        if (selectedInstitution) {
            institutionGraduationTypes = getInstitutionOrUserGraduationTypes(selectedInstitution, currentRoleLevel);
        } else {
            institutionGraduationTypes = getInstitutionOrUserGraduationTypes(user, currentRoleLevel);
        }
        if (
            institutionGraduationTypes &&
            institutionGraduationTypes.length > 0
        ) {
            const belongToHandlingDegree = institutionGraduationTypes.flatMap(grad =>
                (grad.handlingDegreeAndDepartments || [])).find(dept => dept.isBelongsTo);
            Auth.setCurrentHandlingDegreeDept(getSelectedDegreeDeptForForCurrentRoleLevelIsDegree(belongToHandlingDegree?belongToHandlingDegree:institutionGraduationTypes[0].handlingDegreeAndDepartments[0]));
        } else if (user.handlingDepartments && user.handlingDepartments.length > 0) {
            let belongToHandlingDegree=user.handlingDepartments.find(handlingDept => handlingDept.isBelongsTo);
            Auth.setCurrentHandlingDegreeDept(belongToHandlingDegree?belongToHandlingDegree:user.handlingDepartments[0]);
        }

        if (currentRoleLevel && currentRoleLevel != "NO_LEVEL") {
            document.getElementById("degreeSwitchDropdown").style.display = "block";
            setDegreeSwitchDetails(currentRoleLevel);
        } else {
            document.getElementById("degreeSwitchDropdown").style.display = "none";

        }
    } else {
        document.getElementById("degreeSwitchDropdown").style.display = "none";
    }
}

/**
 * @description getSelectedDegreeDeptForForCurrentRoleLevelIsDegree is used to get handlingDepartment matching with handlingDegreeAndDepartment
 * @param {*} handlingDegreeAndDepartment 
 * @returns the matched handlingDepartment
 */
function getSelectedDegreeDeptForForCurrentRoleLevelIsDegree(handlingDegreeAndDepartment) {
    if(user.handlingDepartments?.length > 0) {
        return user.handlingDepartments.find(handlingDept =>
             (handlingDept.concatenatedDegreeAndBatch  && handlingDegreeAndDepartment.concatenatedDegreeAndBatch) ?
              handlingDept.concatenatedDegreeAndBatch === handlingDegreeAndDepartment.concatenatedDegreeAndBatch : (
               (handlingDept.degreeId  && handlingDegreeAndDepartment.degreeId ) ? 
               handlingDept.degreeId === handlingDegreeAndDepartment.degreeId :true));
    }
}

/**
 * @description getInstitutionOrUserGraduationTypes is used to get institutionOrUserGraduationTypes from Logged in user.
 * @param {*} institutionOrUser 
 * @param {*} currentRoleLevel 
 * @returns 
 */
function getInstitutionOrUserGraduationTypes(institutionOrUser, currentRoleLevel) {
    return (currentRoleLevel === 'DEGREE') ? institutionOrUser.graduationTypes :
        (currentRoleLevel === 'DEPARTMENT') ? institutionOrUser.handlingDepartments?.reduce((acc, handlingDegreeDept) => {
            const { graduationType } = handlingDegreeDept;
            let existingGraduationType = acc.find(item => item.graduationType === graduationType);
            if (!existingGraduationType) {
                acc.push({
                    graduationType,
                    handlingDegreeAndDepartments: [handlingDegreeDept],
                    handlingDepartments: null
                });
            } else {
                existingGraduationType.handlingDegreeAndDepartments.push(handlingDegreeDept);
            }
            return acc;
        }, []) : [];
};


/**
 * @description getHandlingDegreeDepartments is used to get HandlingDegreeDepartments from server based on userid and role.
 *
 * @author Arupananda P
 * @since June 26, 2020
 */
function getInstitutionsDetails() {
    if (Auth.getAcademicLevel() != 'UNIVERSITY') {
        const selectedRole = roles.find(role => role.roleName === currentRole);
        if (selectedRole && user.institutions != undefined) {
            document.getElementById("institutionSwitchDropdown").style.display = "block";
        } else {
            document.getElementById("institutionSwitchDropdown").style.display = "none";
        }
        setInstitutionSwitchDetails();
    } else {
        document.getElementById("institutionSwitchDropdown").style.display = "none";
    }
}

/**
 * @description setDegreeSwitchDetails is used to intial degree switch html element on header load
 *
 * @author Masthanaiah K
 * @since Feb 13, 2025
 */
function setDegreeSwitchDetails(currentRoleLevel) {
    if (institutionGraduationTypes && institutionGraduationTypes.length > 0) {
        var currentHandlingDegreeDept = Auth.getCurrentHandlingDegreeDept();
        if (currentRoleLevel === 'DEGREE') {
            document.getElementById("currentDegree").innerText = currentHandlingDegreeDept?.concatenatedDegreeAndBatch ?currentHandlingDegreeDept?.concatenatedDegreeAndBatch : currentHandlingDegreeDept.degreeId;
        } else if (currentRoleLevel === 'DEPARTMENT') {
            document.getElementById("currentDegree").innerText = currentHandlingDegreeDept?.cancatenatedDegreeAndDept;
        }
        var degreeSwitchHtml = "";
        institutionGraduationTypes.forEach((institutionGraduation) => {
            if (institutionGraduation.graduationType != null) {
                degreeSwitchHtml += `<div class="degree-switch-content">
                <p class="arrow-heading"></p>
                <p class="arrow-heading-content"> ${institutionGraduation.graduationType} Degree </p>
              </div>
              <div class="degree-switch-content">`;
                for (
                    let index = 0; index < institutionGraduation.handlingDegreeAndDepartments?.length; index++
                ) {
                    var degreeSwitchDisplayName = '';
                    if (currentRoleLevel === 'DEGREE') {
                        degreeSwitchDisplayName =institutionGraduation.handlingDegreeAndDepartments[index]?.concatenatedDegreeAndBatch ?institutionGraduation.handlingDegreeAndDepartments[index]?.concatenatedDegreeAndBatch : institutionGraduation.handlingDegreeAndDepartments[index]?.degreeId;
                    } else if (currentRoleLevel === 'DEPARTMENT') {
                        degreeSwitchDisplayName = institutionGraduation.handlingDegreeAndDepartments[index]?.cancatenatedDegreeAndDept;
                    }
                    if (document.getElementById("currentDegree").innerText === degreeSwitchDisplayName) {
                        degreeSwitchHtml +=
                            '<button class="root-btn selected-btn degree-switch-btn" id=' +

                            degreeSwitchDisplayName.replace(/\s+/g, "") +
                            ">" +
                            degreeSwitchDisplayName +
                            "</button>";
                    } else {
                        degreeSwitchHtml +=
                            '<button class="root-btn degree-switch-btn "id=' +
                            degreeSwitchDisplayName.replace(/\s+/g, "") +
                            ">" +
                            degreeSwitchDisplayName +
                            "</button>";
                    }
                }
                degreeSwitchHtml += "</div>";
            }

        });
        document.getElementById(
            "degreeSwitchDropdownContent"
        ).innerHTML = degreeSwitchHtml;
    } else {
        document.getElementById("degreeSwitchDropdown").style.display = "none";
    }
}

/**
 * @description setInstitutionSwitchDetails is used to intial institution switch html element on header load
 *
 * @author Vidya Kumari
 * @since July 18, 2024
 */
function setInstitutionSwitchDetails() {
    if (user?.institutions && user.institutions?.length > 0) {
        const currentInstitution = Auth.getCurrentHandlingInstitution();
        if (!currentInstitution) {
            currentInstitution = user.institutions[0];
        }
        if (user.institutions?.length > 1) {
            document.getElementById("currentInstitution").innerText = currentInstitution?.institutionShortName;
            var institutionSwitchHtml = "";
            institutionSwitchHtml += `<div class="degree-switch-content">
            <p class="arrow-heading"></p>
            <p class="arrow-heading-content"> COLLEGES </p>
          </div>
          <div class="degree-switch-content">`;
            user.institutions.forEach((institution) => {
                if (institution.institutionId != null) {
                    const instituteSwitchDisplayName = institution.institutionShortName;
                    if (instituteSwitchDisplayName == currentInstitution?.institutionShortName) {
                        institutionSwitchHtml +=
                            '<button class="root-btn selected-btn degree-switch-btn "id=' +
                            institution.institutionId.replace(/\s+/g, "") +
                            ">" +
                            instituteSwitchDisplayName +
                            "</button>";
                    } else {
                        institutionSwitchHtml +=
                            '<button class="root-btn degree-switch-btn "id=' +
                            institution.institutionId.replace(/\s+/g, "") +
                            ">" +
                            instituteSwitchDisplayName +
                            "</button>";
                    }
                }
            });
            institutionSwitchHtml += "</div>";
            document.getElementById(
                "institutionSwitchDropdownContent"
            ).innerHTML = institutionSwitchHtml;
        } else {
            document.getElementById("institutionSwitchDropdown").style.display = "none";
        }
        getHandlingDegreeDepts(currentInstitution);
    } else {
        document.getElementById("institutionSwitchDropdown").style.display = "none";
        getHandlingDegreeDepts(null);
    }
}

/**
 * @description setInstituteBtnClickFunctions is to set the click functions to Institutions
 * @author Masthanaiah K
 * @since Feb 13 2025
 * @param {*} event 
 */
function setInstituteBtnClickFunctions(event) {
    const selectedInstitution = getHandlingInstitutions(event.target.innerHTML);
    if (selectedInstitution) {
        document.getElementById("currentInstitution").innerText = event.target.innerHTML;

        // To Unselect the previously Selected button
        document.getElementById("institutionSwitchDropdownContent").innerHTML = document.getElementById("institutionSwitchDropdownContent").innerHTML.replace("selected-btn", "");
        
        // To Add the "selected-btn" styling to the selected button
        document.getElementById(event.target.id).classList.add("selected-btn");
        hideInstitutionSwitchDropdown();
        Auth.setCurrentHandlingInstitution(selectedInstitution);
        getHandlingDegreeDepts(selectedInstitution);

        history.pushState(null, "refresh",   "/"+Auth.getTenantId()+"/#/"+"auth-mf/refresh");

        sideNavClicked(null,false);
    } else {
        hideInstitutionSwitchDropdown();
    }
}

/**
 * @description setDegreeSwitchBtnClickFunctions is to set the click functions to DegreeAndDepartments
 * @author Masthanaiah K
 * @since Feb 13 2025
 * @param {*} event 
 */
function setDegreeSwitchBtnClickFunctions(event) {
    if (getHandlingDegreeDepartmentFromDisplayName(event.target.innerHTML)) {
        document.getElementById("currentDegree").innerText = event.target.innerHTML;

        // To Unselect the previously Selected button
        document.getElementById("degreeSwitchDropdownContent").innerHTML = document.getElementById("degreeSwitchDropdownContent").innerHTML.replace("selected-btn", "");

        // To Add the "selected-btn" styling to the selected button
        document.getElementById(event.target.id).classList.add("selected-btn");
        hideDegreeSwitchDropdown();

        history.pushState(null, "refresh",   "/"+Auth.getTenantId()+"/#/"+"auth-mf/refresh");
        sideNavClicked(null,false);
    } else {
        hideDegreeSwitchDropdown();
    }
}

/**
 * @description getHandlingDegreeDepartmentFromDisplayName is to get the handling HandlingDegreeDepartment
 *
 * @author Masthanaiah K
 * @since Feb 13, 2025
 * @param {*} degreeSwitchDisplayName 
 * @returns 
 */
function getHandlingDegreeDepartmentFromDisplayName(degreeSwitchDisplayName) {
    for (let institutionGraduation of institutionGraduationTypes) {
        if (institutionGraduation.handlingDegreeAndDepartments) {
            for (let handlingDegreeDept of institutionGraduation.handlingDegreeAndDepartments) {
                if (currentRoleLevel == "DEGREE" && handlingDegreeDept.concatenatedDegreeAndBatch === degreeSwitchDisplayName) {
                    Auth.setCurrentHandlingDegreeDept(getSelectedDegreeDeptForForCurrentRoleLevelIsDegree(handlingDegreeDept));
                    return handlingDegreeDept;
                } else if (currentRoleLevel == "DEPARTMENT" && handlingDegreeDept.cancatenatedDegreeAndDept === degreeSwitchDisplayName) {
                    Auth.setCurrentHandlingDegreeDept(handlingDegreeDept);
                    return handlingDegreeDept;
                }
            }
        }
    }
    return null;
}

/**
 * @description getHandlingInstitutions is to get the selected Institution
 * @param {*} institutionId 
 * @returns 
 */
function getHandlingInstitutions(instituteSwitchDisplayName) {
    for (let index = 0; index < user.institutions?.length; index++) {
        if (user.institutions[index]?.institutionShortName === instituteSwitchDisplayName) {
            return user.institutions[index];
        }
    }
    return null;
}

/**
 * @description getDegreeSwitchDetails is call on click of degree switch header.
 *
 * @author Arupananda P
 * @since June 26, 2020
 */
function getDegreeSwitchDetails() {
    if (screen.width > 480) {
        document.getElementById("degreeSwitchDropdownContent").style.marginRight =
            document.querySelector("#helpdeskbtn").clientWidth +
            document.querySelector("#notificationbtn").clientWidth +
            document.querySelector("#rolebtn").clientWidth +
            document.querySelector("#institutionSwitchDropdownContent").clientWidth +
            document.querySelector("#themeSwitchBtn").clientWidth +
            "px";
    }
    hideNotificationDropdown();
    hideHelpDeskDropdown();
    hideRoleDropdown();
    hideGlobalSearchDropdown();
    hideInstitutionSwitchDropdown();
    hideThemeDropdown();
    if (
        document
            .getElementById("degreeSwitchDropdownContent")
            .classList.contains("show-top-animation")
    ) {
        hideDegreeSwitchDropdown();
    } else {
        showDegreeSwitchDropdown();
    }
}

function initalHeaderAndFooterLoad() {
    if (window.screen.width > 768) {
        openNavBar();
    } else {
        closeNavBar();
    }
}
/************nav bar toggle**************/
function openCloseNav() {
    if (document.getElementById("mySidebar").classList.contains("full-sidebar")) {
        toggleBtnClicked = false;
        closeNavBar();
    } else {
        toggleBtnClicked = true;
        openNavBar();
    }
}

function changeRole(event) {
    checkToChangeRole(event.target.id).then((response) => {
        if (response === "true") {
            if (stompClient !== null && stompClient !== undefined) {
                stompClient.disconnect();
                // stompClient = null;
            }
            Auth.setCurrentRole(event.target.id);
            currentRole = Auth.getCurrentRole();
            document.getElementById("username").innerHTML =
                getEmptyIfNull(title) +
                " " +
                getEmptyIfNull(name) +
                " " +
                getEmptyIfNull(lastName) +
                " [ " +
                getRoleDisplayName(roles, currentRole) +
                " ] ";
            document.getElementById("mainSideNav").innerHTML = "";
            getNomenclatureConfiguration(true);
            Auth.removeCurrentHandlingDegreeDept();
            setInstitutionSwitchDetails();
        }
    });
}



function setEmails(helpDeskDetails) {
    var i,
        emails = "";
    for (i = 0; i < helpDeskDetails.email.length; i++) {
        var email = helpDeskDetails.email[i] + "<br>";
        emails += email;
    }
    document.getElementById("organizationEmail").innerHTML = "Email: " + emails;
}

function setContactNumbers(helpDeskDetails) {
    var j,
        contactNos = "";
    for (j = 0; j < helpDeskDetails.contactNo.length; j++) {
        var contactNo = helpDeskDetails.contactNo[j] + "<br>";
        contactNos += contactNo;
    }
    document.getElementById("organizationContactNo").innerHTML =
        "Phone no: " + contactNos;
}

function setRoleBtnClickFunctions() {
    var inputs, index;
    inputs = document.getElementsByTagName("button");
    for (index = 0; index < inputs.length; index++) {
        if (isRole(inputs[index].id, user.roles)) {
            inputs[index].onclick = (e) => {
                changeRole(e);
            };
        }
    }
}


/**************getting role**************/
function getAllRoles() {
    document.getElementById("roleDropdown").style.marginRight = 0;
    hideNotificationDropdown();
    hideHelpDeskDropdown();
    hideDegreeSwitchDropdown();
    hideGlobalSearchDropdown();
    hideInstitutionSwitchDropdown();
    hideThemeDropdown();
    var currentRole = Auth.getCurrentRole();

    setUserImageAndDetails(user, currentRole);

    createRoleSwichButtons(user, currentRole);

    if (
        document
            .getElementById("roleDropdown")
            .classList.contains("show-top-animation")
    ) {
        hideRoleDropdown();
    } else {
        showRoleDropdown();
    }
    setRoleBtnClickFunctions();

}

function showFeeDetailsDropDownContent() {
    if (
        document
            .getElementById("feeDetailsDropdown")
            .classList.contains("show-top-animation")
    ) {
        removeTopAnimation("feeDetailsDropdown", "feeDetailsbtn");
    } else {
        addTopAnimation("feeDetailsDropdown", "feeDetailsbtn");
    }

}

function getStudentFeeDetailsByConfigurationForHeader(){
    getAdmissionCommonConfig().then((response) =>{
        if(response != undefined && response.statusCode != "BAD_REQUEST"){
            admissionCommonConfiguration = response;
           
            getStudentFeeDetailsByConfiguration().then((response) => {
              
                if(response != undefined && response.statusCode != "BAD_REQUEST"){
                    studentFeeDetails = response;
                    let symbol = getCurrencySymbol();
                    document.getElementById("currencySymbolfromConfig").innerHTML = symbol;
                    document.getElementById("currencySymbol1").innerHTML = symbol;
                    if(studentFeeDetails.enableFeePaymentInHeaderForRoles != null && studentFeeDetails.enableFeePaymentInHeaderForRoles.includes(Auth.getCurrentRole())){
                        document.getElementById("feeDetailsbtn").classList.remove("hide");
                        document.getElementById("feeDetails").classList.remove("hide");
                        if(studentFeeDetails.shouldHideYearOrTermNumber){
                            document.getElementById("hideTermOrYear").classList.remove("hide");
                            document.getElementById("showYearOrTerm").classList.add("hide");

                            document.getElementById("totalBalanceNoTermOrYear").innerHTML = studentFeeDetails.overallBalanceAmount;
                            document.getElementById("totalPayableNoTermOrYear").innerHTML = studentFeeDetails.overallPayableAmount;
                            document.getElementById("totalBalNoTermOrYearSymbol").innerHTML = symbol;
                            document.getElementById("totalPayableNoTermOrYearSymbol").innerHTML = symbol;
                            if(admissionCommonConfiguration.shouldHideYearOrTermNumber && studentFeeDetails.termwiseFeeDetailsList!=null && studentFeeDetails.termwiseFeeDetailsList.length === 1){
                                document.getElementById("totalPaidNoTermOrYear").classList.remove('hide');
                                document.getElementById("totalPaidNoTermOrYearSymbol").innerHTML = symbol;
                                document.getElementById("totalPaidNoTermOrYear").innerHTML = studentFeeDetails.overallPaidAmount;
                            }else{
                                document.getElementById("totalPaidNoTermOrYear").classList.add('hide');
                            }
                            
                        }else{
                            document.getElementById("hideTermOrYear").classList.add("hide");
                            document.getElementById("showYearOrTerm").classList.remove("hide");
                            if(admissionCommonConfiguration.shouldHideYearOrTermNumber && studentFeeDetails.termwiseFeeDetailsList!=null && studentFeeDetails.termwiseFeeDetailsList.length === 1){
                                document.getElementById("totalPay").classList.remove("hide");
                                document.getElementById("totalBal").classList.remove("hide"); 
                               
                                document.getElementById("previousBalance").classList.add("hide");
                                document.getElementById("currYearPayable").classList.add("hide");
                                document.getElementById("curYearPaid").classList.add("hide");
                                document.getElementById("curYearBal").classList.add("hide");

                                document.getElementById("totalPaySymbol").innerHTML = symbol;
                                document.getElementById("totalBalSymbol").innerHTML = symbol;

                                document.getElementById("totalPayable").innerHTML = studentFeeDetails.currentYearPayable;
                                document.getElementById("totalBalance").innerHTML = studentFeeDetails.currentYearBalance;

                            }else{
                                document.getElementById("previousBalance").classList.remove("hide");
                                document.getElementById("currYearPayable").classList.remove("hide");
                                document.getElementById("curYearPaid").classList.remove("hide");
                                document.getElementById("curYearBal").classList.remove("hide");

                                document.getElementById("totalPay").classList.add("hide");
                                document.getElementById("totalBal").classList.add("hide"); 

                                document.getElementById("prevSymbol").innerHTML = symbol;
                                document.getElementById("currYearPayableSymbol").innerHTML = symbol;
                                document.getElementById("curYearPaidSymbol").innerHTML = symbol;
                                document.getElementById("curYearBalSymbol").innerHTML = symbol;

                                document.getElementById("prevBalance").innerHTML = studentFeeDetails.totalBalance;
                                document.getElementById("currentYearPayable").innerHTML = studentFeeDetails.currentYearPayable;
                                document.getElementById("currentYearPaid").innerHTML = studentFeeDetails.currentYearPaidAmount;
                                document.getElementById("currentYearBal").innerHTML = studentFeeDetails.currentYearBalance;

                            }
                            document.getElementById("totalPaidSymbol").innerHTML = symbol;
                            document.getElementById("excessAmtSymbol").innerHTML = symbol;

                            document.getElementById("totalPaidValue").innerHTML = studentFeeDetails.totalPaidAmount;
                            document.getElementById("excessAmount").innerHTML = studentFeeDetails.excessAmount;
                            feeCollectionTermWise = studentFeeDetails.termWiseFeeCollection;
                            if(studentFeeDetails?.termwiseFeeDetailsList[0]?.feeStructureType){
                                feeCollectionTermWise = studentFeeDetails.termwiseFeeDetailsList[0].feeStructureType == 'TERM_WISE;'
                            }
                            if(feeCollectionTermWise){
                                document.getElementById("termWiseFeeDetails").classList.remove('hide');
                                createTermWiseDetails(studentFeeDetails);
                            }else{
                                document.getElementById("termWiseFeeDetails").classList.add('hide'); 
                            }
                            if(studentFeeDetails.displayExistingFeeTemplates && studentFeeDetails.otherFee != null){
                                document.getElementById("otherFeeDetails").classList.remove('hide');
                                if(studentFeeDetails.otherFee.length > 0){
                                    createOtherFeeDetails();
                                }
                            }else{
                                document.getElementById("otherFeeDetails").classList.add('hide'); 
                            }
                        }
                        if(studentFeeDetails.paymentgatewayEnabled){
                            document.getElementById("payBalancebtn").classList.remove("hide");
                        }else{
                            document.getElementById("payBalancebtn").classList.add("hide");
                        }
                        if(studentFeeDetails.feeReceiptGenerationPending){
                            document.getElementById("payBalancebtn").disabled = true;
                            document.getElementById("payBalancebtn").title = "The admin will generate the fee receipt for the previous transaction after sucessful settlement.";
                        }else{
                            document.getElementById("payBalancebtn").disabled = false; 
                            document.getElementById("payBalancebtn").title = "";
                        }
                      
                    }else{
                        document.getElementById("feeDetailsbtn").classList.add("hide");
                        document.getElementById("feeDetails").classList.add("hide");
                    }
                    
                    
                }else{
                    document.getElementById("feeDetailsbtn").classList.add("hide");
                    document.getElementById("feeDetails").classList.add("hide");
                }
            });
        }else{
            document.getElementById("feeDetailsbtn").classList.add("hide");
            document.getElementById("feeDetails").classList.add("hide");
        }
    });
    
}

function getCurrencySymbol(){
    const currencyType = studentFeeDetails?.currencyType;

    if (!currencyType) {
        return '';
    }
    let formatter = new Intl.NumberFormat('en', {
        style: 'currency',
        currency: currencyType, // Use 'currency', not 'currencyCode'
    });

    let parts = formatter.formatToParts(0); // Break the formatted string into parts
    let symbol = parts.find(part => part.type === 'currency').value;
    return symbol;
}

function  createTermWiseDetails(studentFeeDetails){
    var i , termsDatas='';
    var symbol = getCurrencySymbol();
    for (i = 0; i < studentFeeDetails.termwiseFeeDetailsList.length; i++) {
        var term = studentFeeDetails.termwiseFeeDetailsList[i];
    
        var termData = "<b><u>Term :" + term.termNumber + " Details</u></b>" +
    
            "<div class='fee-details-info row'>" +
                "<small class='col-md-6'>Payable Amount (" + symbol + ")</small>" +
                "<small class='col-md-1'>:</small>" +
                "<small class='col-md-5'>" + term.payableAmount + "</small>" +
            "</div>" +
    
            "<div class='fee-details-info row'>" +
                "<small class='col-md-6'>Paid Amount (" + symbol + ")</small>" +
                "<small class='col-md-1'>:</small>" +
                "<small class='col-md-5'>" + term.paidAmount + "</small>" +
            "</div>" +
    
            "<div class='fee-details-info row'>" +
                "<small class='col-md-6'>Balance Amount (" + symbol + ")</small>" +
                "<small class='col-md-1'>:</small>" +
                "<small class='col-md-5'>" + term.balance + "</small>" +
            "</div>";
    
        termsDatas += termData;
    }
    document.getElementById("eachTermDetails").innerHTML = termsDatas;
}

function createOtherFeeDetails(){
    var i , otherFeesDatas='';
    var symbol = getCurrencySymbol();
    for (i = 0; i < studentFeeDetails.otherFee.length; i++) {
        var other = studentFeeDetails.otherFee[i];
    
        var otherData = "<b><u>Year :" + other.currentYear + " Details</u></b>" +
    
            "<div class='fee-details-info row'>" +
                "<small class='col-md-6'>Payable Amount (" + symbol + ")</small>" +
                "<small class='col-md-1'>:</small>" +
                "<small class='col-md-5'>" + other.currentYearPayable + "</small>" +
            "</div>" +
    
            "<div class='fee-details-info row'>" +
                "<small class='col-md-6'>Paid Amount (" + symbol + ")</small>" +
                "<small class='col-md-1'>:</small>" +
                "<small class='col-md-5'>" + other.currentYearPaidAmount + "</small>" +
            "</div>" +
    
            "<div class='fee-details-info row'>" +
                "<small class='col-md-6'>Balance Amount (" + symbol + ")</small>" +
                "<small class='col-md-1'>:</small>" +
                "<small class='col-md-5'>" + other.currentYearBalance + "</small>" +
            "</div>";
    
        otherFeesDatas += otherData;
    }
    document.getElementById("eachYearDetails").innerHTML = otherFeesDatas;
}

function hideFeeDetailsDropDownContent() {
    removeTopAnimation("feeDetailsDropdown", "feeDetailsbtn");
}

export function getNotification() {
    if (screen.width > 480) {
        // document.getElementById("notify").style.marginRight =
        document.querySelector("#rolebtn").clientWidth +
            // document.querySelector("#insbtn").clientWidth + 
            "px";
    }
    document.getElementById("notificationCount").style.display = "none";
    markReadNotifications();
}

function showNotificationPopup() {
    hideRoleDropdown();
    hideHelpDeskDropdown();
    hideDegreeSwitchDropdown();
    hideGlobalSearchDropdown();
    hideInstitutionSwitchDropdown();
    hideThemeDropdown();
    if (
        document.getElementById("notify").classList.contains("show-top-animation")
    ) {
        hideNotificationDropdown();
    } else {
        showNotificationDropdown();
    }
}

function showHelpDeskDetails() {
    document.getElementById("organiztionImg").src =
        "data:image/png;base64," + miniHeaderLogo;
    if (screen.width > 480) {
        document.getElementById("helpdesk").style.marginRight =
            document.querySelector("#notificationbtn").clientWidth +
            document.querySelector("#rolebtn").clientWidth +
            (document.querySelector("#insbtn")?(document.querySelector("#insbtn").clientWidth):0) +"px";
    }
    hideRoleDropdown();
    hideNotificationDropdown();
    hideDegreeSwitchDropdown();
    hideGlobalSearchDropdown();
    hideInstitutionSwitchDropdown();
    hideThemeDropdown();
    if (
        document.getElementById("helpdesk").classList.contains("show-top-animation")
    ) {
        hideHelpDeskDropdown();
    } else {
        showHelpdeskDropdown();
    }
    document.getElementById("organizationName").innerHTML = organizationName;

    setEmails(helpDeskDetails);

    setContactNumbers(helpDeskDetails);
}

function getSearchedUserBasedOnId(id) {
    id = id.split("-")[0];
    for (let index = 0; index < searchResults.length; index++) {
        if (searchResults[index].id === id) {
            return searchResults[index];
        }
    }
    return null;
}

function showGlobalSearchDropDown() {
    addTopAnimation("globalSearchResults", null);
}

function hideGlobalSearchDropdown() {
    //DO NOT REMOVE THIS

     removeTopAnimation("globalSearchResults", null);
}

function setGlobalSearchClickFunctions() {
    // if (searchResults.length !== 0) {
    //     viewAllSearchResults.onclick = function () {
    //         alert("View More Clicked");
    //     };
    // }
    var inputs, index;
    inputs = document.getElementsByTagName("a");
    for (index = 0; index < inputs.length; index++) {
        const anchorTagId = inputs[index].id;
        const filteredUser = getSearchedUserBasedOnId(anchorTagId);
        const isProfileClicked = anchorTagId.split("-").length === 1;
        if (filteredUser) {
            inputs[index].onclick = () => {
                // window.alert(
                //     filteredUser.name +
                //     (isProfileClicked ? "  Profile clicked" : "  SMR clicked")
                // );

            // if(isProfileClicked){
            //     navigateToProfilePage(filteredUser.id);
            // }else{
            //     navigateToSMRPage(filteredUser.id);
            // }

            if (anchorTagId.indexOf("-smr") > -1) {
                // SMR clicked
                navigateToSMRPage(filteredUser.id);
            } else if (anchorTagId.indexOf("-viewYear") > -1) {
                // Year clicked
                viewYearDetail(filteredUser);
            } else {
                // Profile clicked
                navigateToProfilePage(filteredUser.id);
            }
               
            };
            
        }
    }
}

function viewYearDetail(student) {
  
    const queryParams = {
        studentId: String(student.id),
        name: String(student.name),
        usn: String(student.usn),
        academicYear: String(student.academicYear),
        scheme: String(student.scheme),
        deptId: String(student.deptId),
        joiningYear: String(student.joiningAcademicYear),
        degreeid: String(student.degreeId),
        degreebatch: String(student.degreeBatch),
        backTo : "globe-search",


    };
    const queryString = new URLSearchParams(queryParams).toString();

        // Construct the URL
         const usermanagementUrl = `${window.location.origin}/#/user-management-angular/usermanagement/student/particularviewstudent?${queryString}`;
        // Redirect to the same page
           // Update the browser's URL without refreshing the page

         window.history.pushState({}, '', usermanagementUrl);
}

function setGlobalSearchResults() {
    let globalSearchResult = "";
    if (
        searchResults === undefined ||
        searchResults === null ||
        searchResults.length === 0
    ) {
        globalSearchResult += `<div  class="user-row no-users">No Users Found</div>`;
    } else {
    //     searchResults.forEach((result) => {
    //         globalSearchResult +=
    //             `<div class="user-row">
    //       <div style="width: 10%;">
    //           <img class="search-user-image" src="` +
    //             (result.image ? "data:image/png;base64," + result.image : icon) +
    //             `">
    //       </div>
    //       <div class="filtered-user" style="width:60%; color: black; font-size: 14px;">
    //           ${result.name}` +
    //             (result.userType === "STUDENT" || result.userType === "ALUMNI" ?
    //                 `<br /> ${getEmptyIfNull(result.usn)}` :
    //                 "") +
    //             `</div>
    //            <div class="filtered-user cursor-as-pointer content-center" style="width:15%;">
    //             <a id="${result.id}">
    //                 <i class="fa fa-user" aria-hidden="true"></i>
    //                 <br />
    //                 Profile
    //             </a>
    //           </div>
    //          <div class="filtered-user cursor-as-pointer content-center" style="width:15%;">` +
    //             ((result.userType === "STUDENT" || result.userType === "ALUMNI") &&
    //             currentRole !== "STUDENT" &&
    //             currentRole !== "ALUMNI"
    //                 ? `<a id="${result.id}-smr"><i class="fa fa-file-text-o" aria-hidden="true"></i>
    //                    <br />
    //                    SMR</a>`
    //                 : "&nbsp;&nbsp;")  +
    //                 `</div>
    //                 <div class="filtered-user cursor-as-pointer content-center" style="width:15%;">
    //                     <a id="${result.id}-viewYear">
    //                         <i class="fa fa-eye" aria-hidden="true"></i>
    //                         <br />
    //                         Year
    //                     </a>
    //                 </div>
    //               </div>`;
    //     });

    searchResults.forEach((result) => {
        globalSearchResult +=
            `<div class="user-row">
              <div style="width: 10%;">
                  <img class="search-user-image" src="` +
                    (result.image ? "data:image/png;base64," + result.image : icon) +
                    `">
              </div>
              <div class="filtered-user" style="width:60%; color: black; font-size: 14px;">
                  ${result.name}` +
                    (result.userType === "STUDENT" || result.userType === "ALUMNI"
                        ? `<br /> ${getEmptyIfNull(result.usn)}`
                        : "") +
              `</div>
              <div class="filtered-user cursor-as-pointer content-center" style="width:15%;">
                  <a id="${result.id}">
                      <i class="fa fa-user" aria-hidden="true"></i>
                      <br />
                      Profile
                  </a>
              </div>
              <div class="filtered-user cursor-as-pointer content-center" style="width:15%;">` +
                ((result.userType === "STUDENT" || result.userType === "ALUMNI") &&
                currentRole !== "STUDENT" &&
                currentRole !== "ALUMNI"
                    ? `<a id="${result.id}-smr"><i class="fa fa-file-text-o" aria-hidden="true"></i>
                       <br />
                       SMR</a>`
                    : "&nbsp;&nbsp;") +
              `</div>
              <div class="filtered-user cursor-as-pointer content-center" style="width:15%;">` +
                (result.userType === "STUDENT"
                    ? `<a id="${result.id}-viewYear">
                         <i class="fa fa-eye" aria-hidden="true"></i>
                         <br />
                         Year Details
                       </a>`
                    : "&nbsp;&nbsp;") +
              `</div>
            </div>`;
    });
    
    
    // //     globalSearchResult += `<div id="viewAllSearchResults" class="user-row view-more-results cursor-as-pointer">
    //    View More &gt;&gt; 
    // </div>`;
    }
    document.getElementById("globalSearchResults").innerHTML = globalSearchResult;
    if (screen.width > 480) {
        document.getElementById("globalSearchResults").style.marginRight =
            document.querySelector("#helpdeskbtn").clientWidth +
            document.querySelector("#institutionSwitchbtn").clientWidth +
            document.querySelector("#degreeSwitchBtn").clientWidth +
            document.querySelector("#notificationbtn").clientWidth +
            document.querySelector("#rolebtn").clientWidth +
            document.querySelector("#themeSwitchBtn").clientWidth +
            "px";
    }
    if (!document
        .getElementById("globalSearchResults")
        .classList.contains("show-top-animation")
    ) {
        showGlobalSearchDropDown();
        hideRoleDropdown();
        hideNotificationDropdown();
        hideDegreeSwitchDropdown();
        hideInstitutionSwitchDropdown();
        hideHelpDeskDropdown();
        hideThemeDropdown();
    }
    setGlobalSearchClickFunctions();
}

// Change password DTO
function setEvents() {
    // To get the element of change password modal
    modal = document.getElementById("change-password-modal");

    logoutConfirmModal = document.getElementById("logout-confirmation-modal");

    themeModal = document.getElementById("change-theme-modal");

    togglebtn.onclick = function () {
        openCloseNav();
    };

    institutionSwitchbtn.onclick = function () {
        setInstituteSwitchDetails();
    };

    degreeSwitchBtn.onclick = function () {
        getDegreeSwitchDetails(); 
    };
    helpdeskbtn.onclick = function () {
        showHelpDeskDetails();
    };

    themeSwitchBtn.onclick = function () {
        getUserPreferenceConfig();
    };

    themeSwitchBtn1.onclick = function () {
        openThemeModal();
        renderThemes();
    }

    closethememodal.onclick = function () {
        closeThemeModal();
    };

    applyChangesBtn.onclick = function () {
        applyTheme(selectedTheme);
    }

    notificationbtn.onclick = function () {
        getNotification();
        showNotificationPopup();
    };

    notification.onclick = function () {
        routeToMiscellaneousNotification();
    };

    rolebtn.onclick = function () {
        getAllRoles();
    };

    openChangePassword.onclick = function () {
        openModal();
    };
    closebtn.onclick = function () {
        closeModal();
    };

    const closemodal = document.getElementById("closemodal");
    if (!closemodal) {
        return;
    }
    
    closemodal.onclick = function () {
        closeModal();
    };
 
    currentPassword.onkeyup = function () {
        checkCurrentPassword();
        validateForm();
    };

    newPassword.onkeyup = function () {
        validateForm();
    };

    confirmPassword.onkeyup = function () {
        validateForm();
    };

    changePasswordBtn.onclick = function () {
        changePassword();
    };
    logoutBtn.onclick = function () {
        setUserSessionOut(user.email, user.userName).then((response) => {
            Auth.logout();
        });
    };
    logoutconfbtn.onclick = function () {
        setUserSessionOut(user.email, user.userName).then((response) => {
            closeLogoutConfirmModal();
            Auth.logout();
        });
    };

    logoId.onmouseover = function () {
        if (toggleBtnClicked == false) {
            openNavBar();
        }
    };

    logoId.onmouseout = function () {
        if (toggleBtnClicked == false) {
            closeNavBar();
        }
    };

    mySidebar.onmouseover = function () {
        if (toggleBtnClicked == false) {
            openNavBar();
        }
    };

    mySidebar.onmouseout = function () {
        if (toggleBtnClicked == false) {
            closeNavBar();
        }
    };

    feeDetailsbtn.onclick = function () {
        showFeeDetailsDropDownContent();
    };

    payBalancebtn.onclick = function(){
        navigateToPaymentPage();
    };

    feeDetailsBtn.onclick = function (event) {
        toggleFeeWallet("Fee Details", event);
    };

    walletDetailsBtn.onclick = function (event) {
        toggleFeeWallet("Wallet", event);
    };
    wallethistory.onclick= function(){
        navigateToWalletHistory();
    };
        const searchbtn = document.getElementById("searchbtn");

    // DON'T REMOVE THIS CODE
    if(searchbtn){
    searchbtn.onclick = function() {
        setSearchBar();
    };
}
        const globalSearchIcon = document.getElementById("globalSearchIcon");

if(globalSearchIcon){
    globalSearchIcon.onclick = function() {
        setSearchBar();
    };
}
        const searchicon = document.getElementById("searchicon");

if(searchicon){
    searchicon.onclick = function() {
        setSearchBar();
    };

}
    function setSearchBar() {
        if (screen.width <= 480) {
            document.getElementById("degreeSwitchBtn").classList.add("hide");
            document.getElementById("helpdeskbtn").classList.add("hide");
            document.getElementById("notificationbtn").classList.add("hide");
            document.getElementById("rolebtn").classList.add("hide");
            document.getElementById("institutionSwitchbtn").classList.add("hide");
            document.getElementById("searchbtn") && (document.getElementById("searchbtn").classList.add("hide"));
            document.getElementById("globalSearch") && (document.getElementById("globalSearch").classList.remove("hide"));
            document.getElementById("globalSearchInput") && (document.getElementById("globalSearchInput").classList.remove("hide"));
            document.getElementById("themeSwitchBtn").classList.remove("hide");
            document.getElementById("globalSearchInput") && (document.getElementById("globalSearchInput").classList.add("header-search-input-animation"));
        }
    }
   const globalSearchInput =document.getElementById("globalSearchInput")
    // DON'T REMOVE THIS CODE
    if(globalSearchInput){
    globalSearchInput.onclick = function(event) {
        if (
            event.target.value !== null &&
            event.target.value !== "" &&
            !document
            .getElementById("globalSearchResults")
            .classList.contains("show-top-animation")
        ) {
            showGlobalSearchDropDown();
            hideRoleDropdown();
            hideNotificationDropdown();
            hideDegreeSwitchDropdown();
            hideHelpDeskDropdown();
            hideThemeDropdown();
        }
    };

    globalSearchInput.onkeyup = function(event) {
        const searchedText = event.target.value;
        if (
            searchedText === null ||
            searchedText === undefined ||
            searchedText === ""
        ) {
            searchResults = [];
            setGlobalSearchResults();
            hideGlobalSearchDropdown();
        } else {
            searchUser(searchedText).then((response) => {
                searchResults = response;
                setGlobalSearchResults();
            });
        }
    };
    }
    // If the user clicks anywhere outside of the modal, it will close the modal
    window.onclick = function (event) {
        if (event.target == modal) {
            modal.style.display = "none";
        }
        if (
            event.target.id != "helpdeskbtn" &&
            event.target.id != "helpdeskIcon" &&
            event.target.id != "notificationbtn" &&
            event.target.id != "notificationCount" &&
            event.target.id != "userImageCircleId" &&
            event.target.id != "userHeaderIcon" &&
            event.target.id != "userHeaderImage" &&
            event.target.id != "notificationIcon" &&
            event.target.id != "rolebtn" &&
            event.target.id != "username" &&
            event.target.id != "settingIcon" &&
            event.target.id != "userIcon" &&
            event.target.id != "degreeSwitchBtn" &&
            event.target.id != "institutionSwitchbtn" &&
            event.target.id != "degree-switch-icon" &&
            event.target.id != "currentDegree" &&
            event.target.id != "degree-switch-icon2" &&
            event.target.id != "degree-switch-icon1" &&
            event.target.id != "globalSearchInput" &&
            event.target.id != "institution-switch-icon" &&
            event.target.id != "institution-switch-icon2" &&
            event.target.id != "currentInstitution" && 
            event.target.id != "themeSwitchBtn" && event.target.id != "themeSwitchIcon"
        ) {
            hideRoleDropdown();
            hideNotificationDropdown();
            hideHelpDeskDropdown();
            setInstituteBtnClickFunctions(event);
            setDegreeSwitchBtnClickFunctions(event);
            hideGlobalSearchDropdown();
            hideInstitutionSwitchDropdown();
            hideThemeDropdown();
        }
        if (
            event.target.id != "searchbtn" &&
            event.target.id != "searchiconbtn" &&
            event.target.id != "searchicon" &&
            event.target.id != "globalSearchInput" &&
            event.target.id != "panel-menu" &&
            event.target.id != "togglebtn"
        ) {
            if (screen.width <= 480) {
                document.getElementById("degreeSwitchBtn").classList.remove("hide");
                document.getElementById("helpdeskbtn").classList.remove("hide");
                document.getElementById("notificationbtn").classList.remove("hide");
                document.getElementById("rolebtn").classList.remove("hide");
                document.getElementById("institutionSwitchbtn").classList.remove("hide");
                document.getElementById("searchbtn") && (document.getElementById("searchbtn").classList.remove("hide"));
                document.getElementById("globalSearch") && (document.getElementById("globalSearch").classList.add("hide"));
                document.getElementById("globalSearchInput") && (document.getElementById("globalSearchInput").classList.add("hide"));
                document.getElementById("globalSearchInput") && (document.getElementById("globalSearchInput").classList.remove("header-search-input-animation"));
                document.getElementById("themeSwitchBtn").classList.remove("hide");
            }
        }
    };

    initalHeaderAndFooterLoad();
}

function test() {
    var img = document.createElement("img");
    img.src = gears;
    document.getElementById("loderImg").appendChild(img);
}

export function getHeadDetails() {
    //here 
    document.getElementById("header").innerHTML = header;
    manageHeaderForSmallWidths();
    getUniversity();
    setUserDetails();
    setEvents();
    getStudentFeeDetailsByConfigurationForHeader();
    getCollegeData().then(function () {
        setHeaderLogo();
        setCollegeName();
    });

    getHelpDeskInfo().then((response) => {
        helpDeskDetails = response;
        organizationName = helpDeskDetails.organizationName;
    });
    setNotificationCount();
    getInstitutionsDetails();
    
    test();
    // getWebSocket();

}

function getUniversity() {
    if (Auth.getSourceAcademicLevel() == 'COLLEGE') {

        Auth.setAcademicLevel('COLLEGE');
        Auth.setSelectedAcademicLevel('COLLEGE');
    } else {

        Auth.setAcademicLevel('UNIVERSITY');
        Auth.setSelectedAcademicLevel('UNIVERSITY');
    }
}

function getCurrentRoleLevel() {
    let currentRole = Auth.getCurrentRole();
    let role = Auth.getUser().roles.find(role => role.roleName === currentRole);
    if (role && role.roleLevel) {
        return role.roleLevel;
    } else {
        return 'NO_LEVEL';
    }
}


function getCollegeDetails(tenantId) {
    const myRequest = new Request(getURL("COLLEGE").url + '/backgroundimageconfig/header/collegeinfo', {
        method: 'GET',
        headers: getHeaders(tenantId),
        mode: 'cors',
        cache: 'default',
    });

    return fetch(myRequest)
        .then(response => response.json())
        .then(response => {
            Auth.setCollegeDetails(response);
            return response;
        });
}

function getHeaders(tenantId) {
    var headers = new Headers();
    headers = {
        'Content-Type': 'application/json;',
        Authorization: 'Bearer ' + sessionStorage.getItem("token"),
        'tenant-id': tenantId,
        'academic-type': 'COLLEGE',
        Accept: '*/*'
    };
    return headers;
}

/**
 * @description setInstituteSwitchDetails is call on click of Institute switch header.
 *
 * @author Manoj L
 * @since Aug 30, 2023
 */
function setInstituteSwitchDetails() {
    if (screen.width > 480) {
        document.getElementById("institutionSwitchDropdownContent").style.marginRight =
            document.querySelector("#helpdeskbtn").clientWidth +
            document.querySelector("#notificationbtn").clientWidth +
            document.querySelector("#rolebtn").clientWidth +
            document.querySelector("#degreeSwitchDropdownContent").clientWidth +
            document.querySelector("#themeSwitchBtn").clientWidth +
            "px";
    }
    hideNotificationDropdown();
    hideHelpDeskDropdown();
    hideRoleDropdown();
    hideGlobalSearchDropdown();
    hideDegreeSwitchDropdown();
    hideThemeDropdown();
    if (document.getElementById("institutionSwitchDropdownContent").classList.contains("show-top-animation")) {
        hideInstitutionSwitchDropdown();
    } else {
        showInstitutionSwitchDropdown();
    }
}

function showFeeDetailsDropDownContent() {
    if (
        document
            .getElementById("feeDetailsDropdown")
            .classList.contains("show-top-animation")
    ) {
        removeTopAnimation("feeDetailsDropdown", "feeDetailsbtn");
    } else {
        addTopAnimation("feeDetailsDropdown", "feeDetailsbtn");
    }

}

function getStudentFeeDetailsByConfigurationForHeader(){
    getAdmissionCommonConfig().then((response) =>{
        if(response != undefined && response.statusCode != "BAD_REQUEST"){
            admissionCommonConfiguration = response;
           
            getStudentFeeDetailsByConfiguration().then((response) => {
              
                if(response != undefined && response.statusCode != "BAD_REQUEST"){
                    studentFeeDetails = response;
                    // This method disables the "Pay Now" button if the due date for fee payment has passed.
                    initializeUserPaymentDetails(studentFeeDetails.currentYear);
                    let symbol = getCurrencySymbol();
                    document.getElementById("currencySymbolfromConfig").innerHTML = symbol;
                    document.getElementById("currencySymbol1").innerHTML = symbol;
                    if(studentFeeDetails.enableFeePaymentInHeaderForRoles != null && studentFeeDetails.enableFeePaymentInHeaderForRoles.includes(Auth.getCurrentRole())){
                        document.getElementById("feeDetailsbtn").classList.remove("hide");
                        document.getElementById("feeDetails").classList.remove("hide");
                        if(studentFeeDetails.shouldHideYearOrTermNumber){
                            document.getElementById("hideTermOrYear").classList.remove("hide");
                            document.getElementById("showYearOrTerm").classList.add("hide");

                            document.getElementById("totalBalanceNoTermOrYear").innerHTML = studentFeeDetails.overallBalanceAmount;
                            document.getElementById("totalPayableNoTermOrYear").innerHTML = studentFeeDetails.overallPayableAmount;
                            document.getElementById("totalBalNoTermOrYearSymbol").innerHTML = symbol;
                            document.getElementById("totalPayableNoTermOrYearSymbol").innerHTML = symbol;
                            if(admissionCommonConfiguration.shouldHideYearOrTermNumber && studentFeeDetails.termwiseFeeDetailsList!=null && studentFeeDetails.termwiseFeeDetailsList.length === 1){
                                document.getElementById("totalPaidNoTermOrYear").classList.remove('hide');
                                document.getElementById("totalPaidNoTermOrYearSymbol").innerHTML = symbol;
                                document.getElementById("totalPaidNoTermOrYear").innerHTML = studentFeeDetails.overallPaidAmount;
                            }else{
                                document.getElementById("totalPaidNoTermOrYear").classList.add('hide');
                            }
                            
                        }else{
                            document.getElementById("hideTermOrYear").classList.add("hide");
                            document.getElementById("showYearOrTerm").classList.remove("hide");
                            if(admissionCommonConfiguration.shouldHideYearOrTermNumber && studentFeeDetails.termwiseFeeDetailsList!=null && studentFeeDetails.termwiseFeeDetailsList.length === 1){
                                document.getElementById("totalPay").classList.remove("hide");
                                document.getElementById("totalBal").classList.remove("hide"); 
                               
                                document.getElementById("previousBalance").classList.add("hide");
                                document.getElementById("currYearPayable").classList.add("hide");
                                document.getElementById("curYearPaid").classList.add("hide");
                                document.getElementById("curYearBal").classList.add("hide");

                                document.getElementById("totalPaySymbol").innerHTML = symbol;
                                document.getElementById("totalBalSymbol").innerHTML = symbol;

                                document.getElementById("totalPayable").innerHTML = studentFeeDetails.currentYearPayable;
                                document.getElementById("totalBalance").innerHTML = studentFeeDetails.currentYearBalance;

                            }else{
                                document.getElementById("previousBalance").classList.remove("hide");
                                document.getElementById("currYearPayable").classList.remove("hide");
                                document.getElementById("curYearPaid").classList.remove("hide");
                                document.getElementById("curYearBal").classList.remove("hide");

                                document.getElementById("totalPay").classList.add("hide");
                                document.getElementById("totalBal").classList.add("hide"); 

                                document.getElementById("prevSymbol").innerHTML = symbol;
                                document.getElementById("currYearPayableSymbol").innerHTML = symbol;
                                document.getElementById("curYearPaidSymbol").innerHTML = symbol;
                                document.getElementById("curYearBalSymbol").innerHTML = symbol;

                                document.getElementById("prevBalance").innerHTML = studentFeeDetails.totalBalance;
                                document.getElementById("currentYearPayable").innerHTML = studentFeeDetails.currentYearPayable;
                                document.getElementById("currentYearPaid").innerHTML = studentFeeDetails.currentYearPaidAmount;
                                document.getElementById("currentYearBal").innerHTML = studentFeeDetails.currentYearBalance;

                            }
                            document.getElementById("totalPaidSymbol").innerHTML = symbol;
                            document.getElementById("excessAmtSymbol").innerHTML = symbol;

                            document.getElementById("totalPaidValue").innerHTML = studentFeeDetails.totalPaidAmount;
                            document.getElementById("excessAmount").innerHTML = studentFeeDetails.excessAmount;

                            feeCollectionTermWise = studentFeeDetails.termWiseFeeCollection;
                            if(studentFeeDetails?.termwiseFeeDetailsList[0]?.feeStructureType!=null){
                                feeCollectionTermWise = studentFeeDetails.termwiseFeeDetailsList[0].feeStructureType == 'TERM_WISE'
                            }
                            if(feeCollectionTermWise){
                                document.getElementById("termWiseFeeDetails").classList.remove('hide');
                                createTermWiseDetails(studentFeeDetails);
                            }else{
                                document.getElementById("termWiseFeeDetails").classList.add('hide'); 
                            }
                            if(studentFeeDetails.displayExistingFeeTemplates && studentFeeDetails.otherFee != null){
                                document.getElementById("otherFeeDetails").classList.remove('hide');
                                if(studentFeeDetails.otherFee.length > 0){
                                    createOtherFeeDetails();
                                }
                            }else{
                                document.getElementById("otherFeeDetails").classList.add('hide'); 
                            }
                        }
                        if(studentFeeDetails.feeReceiptGenerationPending || disablePayNow){
                            document.getElementById("payBalancebtn").disabled = true;
                            document.getElementById("payBalancebtn").style.opacity = "0.5";
                            if(disablePayNow){
                                
                                document.getElementById("payBalancebtn").title = "Payment cannot be done as Due date is over.";
                            }else{
                                
                                document.getElementById("payBalancebtn").title = "The admin will generate the fee receipt for the previous transaction after sucessful settlement.";
                            }
                        }else{
                            document.getElementById("payBalancebtn").style.opacity = "1";
                            document.getElementById("payBalancebtn").disabled = false; 
                            document.getElementById("payBalancebtn").title = "";
                        }
                      
                    }else{
                        document.getElementById("feeDetailsbtn").classList.add("hide");
                        document.getElementById("feeDetails").classList.add("hide");
                    }
                    
                    
                }else{
                    document.getElementById("feeDetailsbtn").classList.add("hide");
                    document.getElementById("feeDetails").classList.add("hide");
                }
            });
        }else{
            document.getElementById("feeDetailsbtn").classList.add("hide");
            document.getElementById("feeDetails").classList.add("hide");
        }
    });
    
}

function getCurrencySymbol(){
    let formatter = new Intl.NumberFormat('en', {
        style: 'currency',
        currency: studentFeeDetails.currencyType, // Use 'currency', not 'currencyCode'
    });

    let parts = formatter.formatToParts(0); // Break the formatted string into parts
    let symbol = parts.find(part => part.type === 'currency').value;
    return symbol;
}

function  createTermWiseDetails(studentFeeDetails){
    var i , termsDatas='';
    var symbol = getCurrencySymbol();
    for (i = 0; i < studentFeeDetails.termwiseFeeDetailsList.length; i++) {
        var term = studentFeeDetails.termwiseFeeDetailsList[i];
    
        var termData = "<b><u>Term :" + term.termNumber + " Details</u></b>" +
    
            "<div class='fee-details-info row'>" +
                "<small class='col-md-6'>Payable Amount (" + symbol + ")</small>" +
                "<small class='col-md-1'>:</small>" +
                "<small class='col-md-5'>" + term.payableAmount + "</small>" +
            "</div>" +
    
            "<div class='fee-details-info row'>" +
                "<small class='col-md-6'>Paid Amount (" + symbol + ")</small>" +
                "<small class='col-md-1'>:</small>" +
                "<small class='col-md-5'>" + term.paidAmount + "</small>" +
            "</div>" +
    
            "<div class='fee-details-info row'>" +
                "<small class='col-md-6'>Balance Amount (" + symbol + ")</small>" +
                "<small class='col-md-1'>:</small>" +
                "<small class='col-md-5'>" + term.balance + "</small>" +
            "</div>";
    
        termsDatas += termData;
    }
    document.getElementById("eachTermDetails").innerHTML = termsDatas;
}

function createOtherFeeDetails(){
    var i , otherFeesDatas='';
    var symbol = getCurrencySymbol();
    for (i = 0; i < studentFeeDetails.otherFee.length; i++) {
        var other = studentFeeDetails.otherFee[i];
    
        var otherData = "<b><u>Year :" + other.currentYear + " Details</u></b>" +
    
            "<div class='fee-details-info row'>" +
                "<small class='col-md-6'>Payable Amount (" + symbol + ")</small>" +
                "<small class='col-md-1'>:</small>" +
                "<small class='col-md-5'>" + other.currentYearPayable + "</small>" +
            "</div>" +
    
            "<div class='fee-details-info row'>" +
                "<small class='col-md-6'>Paid Amount (" + symbol + ")</small>" +
                "<small class='col-md-1'>:</small>" +
                "<small class='col-md-5'>" + other.currentYearPaidAmount + "</small>" +
            "</div>" +
    
            "<div class='fee-details-info row'>" +
                "<small class='col-md-6'>Balance Amount (" + symbol + ")</small>" +
                "<small class='col-md-1'>:</small>" +
                "<small class='col-md-5'>" + other.currentYearBalance + "</small>" +
            "</div>";
    
        otherFeesDatas += otherData;
    }
    document.getElementById("eachYearDetails").innerHTML = otherFeesDatas;
}

function hideFeeDetailsDropDownContent() {
    removeTopAnimation("feeDetailsDropdown", "feeDetailsbtn");
}

function navigateToPaymentPage(){
    const admissionUrl = `/#/admission-angular/studentlogin/studentregistrationpayment;flag=payment`;
    history.pushState(
        admissionUrl,
        admissionUrl,
        window.location.origin+"/"+Auth.getTenantId()+'/mfrootconfig' + admissionUrl
    );
     document.getElementById("feeDetailsDropdown").classList.add("hide");
    
}

function toggleFeeWallet(type, event) {
    event.stopPropagation();
    const feeDetailsSection = document.getElementById("feeDetailsSection");
    const walletSection = document.getElementById("walletSection");
    const walletAmountElement = document.getElementById("walletAmount");
    if (type === "Fee Details") {

        feeDetailsSection.style.display = "block";
        walletSection.style.display = "none";
        feeDetailsBtn.classList.add("btn-color");
        walletDetailsBtn.classList.remove("btn-color");
    } else {
        walletAmt= getWalletAmount();
        walletAmountElement.textContent = walletAmt;
        feeDetailsSection.style.display = "none";
        walletSection.style.display = "block";
         walletDetailsBtn.classList.add("btn-color");
         feeDetailsBtn.classList.remove("btn-color");
      
    }
}

function getWalletAmount(){
    // Retrieve and parse the user object from sessionStorage
    const user = JSON.parse(sessionStorage.getItem("user")); 
    const walletAmt = user ? user.walletAmount : null;  // Safely access walletAmount
    return walletAmt ;
  }

   function navigateToWalletHistory() {
    history.pushState(
        null,
        "admission-angular/admission/wallet-history",
        "/"+Auth.getTenantId()+"/#/"+"admission-angular/admission/wallet-history"
    );
    hideFeeDetailsDropDownContent();
}

const CryptoJS = require('crypto-js');
function navigateToProfilePage(userId) {
    const key = 'Key@123'; // Encryption key
    // Encrypt the userId
    try {
        const encryptedUserId = CryptoJS.AES.encrypt(userId, key).toString();
        window.sessionStorage.setItem('profileforsearch', encryptedUserId);      
    } catch (error) {
        console.error("Encryption error:", error);
        return;
    }
    // Construct the absolute URL
    const profileUrl = `${window.location.origin}/#/profile-angular/profile`;
    // Navigate to the intended URL
     // Update the browser's URL without refreshing the page
     window.history.pushState({}, '', profileUrl);
}

function navigateToSMRPage(studentId){
      // Construct the URL
      const usermanagementUrl = `${window.location.origin}/#/attendance-angular/attendance/studentsmr/${studentId}`;
    // Redirect to the same page
       // Update the browser's URL without refreshing the page
     window.history.pushState({}, '', usermanagementUrl);
}

function hideSearchBar() {
    const globalSearch = document.getElementById("globalSearch");
    const searchBtn = document.getElementById("searchbtn");

    if (currentRole === "PARENT" || currentRole === "STUDENT") {
        if (globalSearch) {
            globalSearch.remove(); // Removes the element from the DOM
        }
        if(searchBtn){
            searchBtn.remove();
        }
        // globalSearch.style.display = "none";
        //  searchBtn.style.display = "none"; 
    }
}


/**
 * Disables the "Pay Now" button if the due date for fee payment has passed.
 * 
 * This function retrieves student data configuration and due date details based on the degree ID.
 * It then checks if the current academic year, term, and due dates match specific conditions:
 *  - The fee collection is term-wise or year-wise.
 *  - The due date has passed.
 *  - No fine has been applied.
 * 
 * If any due date condition is met, the "Pay Now" button is disabled. Otherwise, it remains enabled.
 */
function setPayNowDisable() {
    getStudentDataConfigByDegreeId(degreeId)
        .then(response => {
            if (response) {
                studentDataConfig = response;
                return getAllDueDateByDegree(degreeId);
            }
        })
        .then(response => {
            if (response) {
                dueDateAndFine = response;
                const currentDate = new Date();
                currentDate.setHours(0, 0, 0, 0);

                feeCollectionTermWise = studentDataConfig.termWiseFeeCollection;
                disablePayNow = dueDateAndFine.some(as => {
                    const isSameAcademicYear = as.academicYear === academicYear;
                    const isIncluded = feeCollectionTermWise ? as.termNumbers.includes(termNumber) : as.degreeYears.includes(currentYear);
                    const isFineNotApplied = !as.fineApplied;

                    const dueDate = new Date(as.dueDate);
                    dueDate.setHours(0, 0, 0, 0);

                    return isSameAcademicYear && isIncluded && isFineNotApplied && currentDate > dueDate;
                });

                updatePayNowButton();
            }
        })
        .catch(error => console.error(error.message));
}

function updatePayNowButton() {
    const btn = document.getElementById("payBalancebtn");

    if (!btn) return;

    if (disablePayNow || studentFeeDetails.feeReceiptGenerationPending) {
        btn.disabled = true;
        btn.style.opacity = "0.5";
        btn.title = disablePayNow
            ? "Payment cannot be done as Due date is over."
            : "The admin will generate the fee receipt for the previous transaction after successful settlement.";
    } else {
        btn.disabled = false;
        btn.style.opacity = "1";
        btn.title = "";
    }
}


function initializeUserPaymentDetails(currentYear) {
    if (currentRole === 'STUDENT') {
        degreeId = user.degreeId;
        academicYear = user.academicYear;
        currentYear = currentYear;
        termNumber = user.termNumber;
        setPayNowDisable();
    } else if (currentRole === 'PARENT') {
        getDefaultInformationForChild(user.childInformation[0].studentId).then((response) => {
            if (response) {
                degreeId = response.degreeId;
                academicYear = response.academicYear;
                currentYear = response.currentYear;
                termNumber = response.termNumber;
                setPayNowDisable();
            }
        }).catch((error) => {
            console.error("Error fetching student data config:", error);
        });

    }
}

function getThemes(){
    hideRoleDropdown();
    hideDegreeSwitchDropdown();
    hideGlobalSearchDropdown();
    hideInstitutionSwitchDropdown();
    if (
        document.getElementById("theme").classList.contains("show-top-animation")
    ) {
        hideThemeDropdown();
    } else {
        showThemeDropdown();
    }    
    
}

function renderThemes() {
    const themesContainer = document.getElementById("themes-container");
    
    themesContainer.innerHTML = "";

    themes.forEach(theme => {
        // Create Theme Box
        const themeDiv = document.createElement("div");
        themeDiv.className = `user-preference-body-content p-2 ${theme.data === selectedTheme ? 'active' : ''}`;
        themeDiv.style.cursor = "pointer";
         themeDiv.onclick = () => selectTheme(theme.data);

        // Theme Row
        themeDiv.innerHTML = `
            <div class="row align-items-center">
                <div class="col-2">${theme.name}</div>
                <div class="col-6">
                    <span class="themechanger" style="background: ${theme.background}; padding: 5px; border-radius: 5px;">
                        <i class="fa fa-circle theme-icon-size" style="color: ${theme.primary};"></i>
                        <i class="fa fa-circle theme-icon-size" style="color: ${theme.secondary}; margin-left: 5px;"></i>
                    </span>
                </div>
                <div class="col-4 d-flex justify-content-end">
                    <input type="radio" name="theme-radio" value="${theme.data}" 
                        class="user-preference-radio" style="cursor: pointer" ${theme.data === selectedTheme ? 'checked' : ''}>
                </div>
            </div>
        `;

        themesContainer.appendChild(themeDiv);
    });
}

// Function to select and apply theme
function selectTheme(themeData) {
    selectedTheme = themeData;

}

// Function to save the selected theme
function applyTheme() {
    const url =
    getURL(Auth.getAcademicLevel()).url +
    `/profile/update-theme/${user.id}?type=WEB&theme=${encodeURIComponent(selectedTheme)}`;

  const myRequest = new Request(url, {
    method: "GET",
    headers: getHeaders(),
    mode: "cors",
    cache: "default",
  });

  fetch(myRequest)
    .then(response => {
      return response.text();
    })
    .then(response => {
        if(response){
        Auth.kcUser();
        }
        closeThemeModal(selectedTheme);
      })
      .catch(error => {
        console.error("Error updating theme:", error);
      });
  }

export function getHeaders() {
    var headers = new Headers();
    headers = {
      'Content-Type': 'application/json;',
      Authorization: 'Bearer ' + sessionStorage.getItem("token"),
      'tenant-id': Auth.getUser().tenantId,
      'academic-type': Auth.getUser().academicLevel,
      Accept: '*/*'
    };
    return headers;
  }

  function getUserPreferenceConfig() {
    const myRequest = new Request(
        getURL(Auth.getAcademicLevel()).url +
        "/userpreferenceconfig/", {
        method: "GET",
        headers: getHeaders(),
        mode: "cors",
        cache: "default",
    }
    ); 
    fetch(myRequest)
        .then((response) => {
            return response.json();
        })
        .then((response) => {
            if (response) {
                getUserPreferenceConfig1(response);
            }
        })
        .catch(error => {
            console.error("Error fetching user preference config:", error);
        });
}

function getUserPreferenceConfig1(response) {
    const userPrefConfigList = response;
    if(userPrefConfigList){
        userPrefConfigList.forEach(config => {
        if (config.feature === 'COLOUR_THEME' && config.webEnabled) {
            getThemes();
        }
      });
    }
  }

  function routeToMiscellaneousNotification() {
    history.pushState({}, '', '/miscellaneous-angular/spaneosadmin/notification');
  }

  function manageHeaderForSmallWidths() {
    if(screen.width <= 450) {
         document.getElementById('logoId').style.display = 'none';
         document.getElementById('searchbtn') && (document.getElementById('searchbtn').style.display = 'none');
         document.getElementById("globalSearch") && (document.getElementById("globalSearch").style.display = 'none');
         document.getElementById('header').style.paddingTop  = "5px";
         document.getElementById('header').style.paddingBottom  = "5px";
         document.getElementById('header').style.paddingRight  = "5px";
         document.getElementById('subapp-container').style.marginTop = "10%";
    } else {
        document.getElementById('logoId').style.display = 'block';
         document.getElementById('searchbtn') && (document.getElementById('searchbtn').style.display = 'block');
         document.getElementById("globalSearch") && (document.getElementById("globalSearch").style.display = 'block');
         document.getElementById('subapp-container').style.marginTop = "3%";
    }
  }

  let isMobile = window.innerWidth;

window.addEventListener("resize", () => {
        manageHeaderForSmallWidths();
});


